import { LookupCard } from '../components/LookupCard'

/**
 * 设置页维护两份下拉名单。放在这里而不是散在各自页面里，是因为改名单是运维动作、
 * 收录是日常动作：混在一起会让人误以为删名字能改历史。
 */
export function Settings() {
  return (
    <section>
      <header className="page-head compact">
        <h1>设置</h1>
      </header>

      <div className="grid two">
        <LookupCard
          path="salespersons"
          label="业务员"
          hint="下单记录页面「业务员」下拉的来源。每次粘贴下单记录前先在这里选到人名。"
        />
        <LookupCard
          path="platforms"
          label="平台"
          hint="入库页面「平台」下拉的来源，也是库存筛选与看板摘要里的取值；名字里不能有逗号或竖线。"
        />
      </div>
    </section>
  )
}
